module.exports = __webpack_public_path__ + "img/Slide1.a644221b.png";